export default "__VITE_ASSET__Cl3wpZ_q__"